import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../css/fullimagebg.css';

class FullImageBg extends Component {
    componentDidMount() {
        //let videoElms = document.getElementsByTagName('video')[0];
        //videoElms.play();
    }

    render() {
        return (
            <div id="fullpageheader" className="carousel slide carousel-fade" data-ride="carousel">
                <div className="carousel-inner" role="listbox">
                    <div className="carousel-item active">
                        <div className="view hm-black-light">
                            {/* 
                            <video className="video-fluid" autoPlay loop muted poster="/video/introsito.jpg">
                                <source src="/video/introsito.mp4" type="video/mp4" />
                            </video>
                            */}
                            <picture>
                                <source type="image/webp" srcset="img/home/bigimage.webp" />
                                <img src="img/home/bigimage.jpg"></img>
                            </picture>
                        </div>
                        <div className="carousel-caption">
                            <div className="flex-center animated fadeIn">
                                <ul>
                                    <li>
                                        <h1 className="display-2 font-bold darkshadow acmefont">Dama<span className="primary-cl primary-shadow">trà</span></h1>
                                    </li>
                                    <li>
                                        <h2 className="display-5 mt-4 mb-5 font-bold darkshadow">La vera energia della musica folk!</h2>
                                    </li>
                                    <li>
                                        <Link className="btn primary-bkg btn-lg px-1" to="/contatti" style={{ width: "40%" }}>Contattaci</Link>
                                        <Link className="btn btn-outline-white btn-lg px-1" to="/concerti" style={{ width: "40%" }}>Seguici</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FullImageBg;


// WEBPACK FOOTER //
// ./src/components/FullImageBg.js